/** Nonstaff biasa dan nonstaff helper memakai aturan bank/rekening yang sama. */
export function isNonstaffStatus(status) {
  return status === "nonstaff" || status === "nonstaff helper";
}

/** URL file wajib Form 1 — harus string non-kosong setelah trim. */
export const FORM1_REQUIRED_FILE_URL_KEYS = [
  "foto_url",
  "ktp_url",
  "npwp_url",
  "kk_url",
  "cv_url",
];

export const FORM1_UPLOAD_DONE = "Upload selesai";

export function hasNonEmptyTrimmedUrl(value) {
  if (value === null || value === undefined) return false;
  if (typeof value !== "string") return false;
  return value.trim() !== "";
}

/** Untuk state React atau dokumen Firestore dengan field yang sama. */
export function isForm1FileUrlsComplete(data) {
  if (!data || typeof data !== "object") return false;
  return FORM1_REQUIRED_FILE_URL_KEYS.every((key) =>
    hasNonEmptyTrimmedUrl(data[key]),
  );
}

function isUploadComplete(status) {
  return status === FORM1_UPLOAD_DONE;
}

function safeTrim(value) {
  return value && typeof value === "string" ? value.trim() : "";
}

function safeBool(value) {
  return value === true;
}

function safeCheck(value) {
  return value !== null && value !== undefined && value !== "";
}

/** Samakan perilaku Form.js: pasangan tidak wajib jika Belum Menikah / Cerai */
function isSpouseFieldsOptional(statusPerdata) {
  return statusPerdata === "Belum Menikah" || statusPerdata === "Cerai";
}

/**
 * Samakan dengan onSubmit: staff → MAS; selain mandiri/mas → kosongkan rekening.
 */
export function normalizeForm1StateForValidation(state) {
  if (!state || typeof state !== "object") return {};
  const s = { ...state };
  if (s.status_karyawan === "staff") {
    s.selected_bank = "mas";
  } else if (s.selected_bank !== "mandiri" && s.selected_bank !== "mas") {
    s.selected_bank = "";
    s.nomor_rekening_bank = "";
  }
  return s;
}

/**
 * Validasi lengkap Form 1 — satu sumber kebenaran untuk UI dan sebelum tulis `form_1_submitted`.
 * @returns {{ ok: boolean, failedFields: string[], failedUploads: string[], rekeningValid: boolean, errorMessage: string }}
 */
export function validateForm1Complete(rawState) {
  const state = normalizeForm1StateForValidation(rawState);

  const {
    nama_lengkap,
    nomor_npwp,
    agama,
    jenis_kelamin,
    tempat_lahir,
    tanggal_lahir,
    tanggal_masuk,
    province,
    regency,
    district,
    village,
    addressDetail,
    nomor_kk,
    status_perdata,
    orang_tua_nama_ayah,
    orang_tua_nama_ibu,
    kontak_darurat_nama,
    kontak_darurat_hubungan,
    kontak_darurat_no_telepon,
    nomor_hp,
    email,
    pendidikan_terakhir,
    pendidikan_nama_sekolah,
    pendidikan_jurusan,
    npwp_pemadanan_checked,
    selected_bank,
    nomor_rekening_bank,
    status_karyawan,
    nomor_kartu_bpjs_kesehatan,
    agreement,

    foto_url,
    ktp_url,
    npwp_url,
    kk_url,
    cv_url,

    foto_pribadi_status,
    foto_ktp_status,
    foto_npwp_status,
    foto_kk_status,
    foto_cv_status,

    nama_pasangan,
    tempat_pernikahan,
    tanggal_pernikahan,
    tempat_lahir_pasangan,
    tanggal_lahir_pasangan,
    pekerjaan_pasangan,
    tempat_pasangan_bekerja,

    kontak_darurat_hubungan_kerabat,
  } = state;

  const isPKLMagang = status_karyawan === "pkl/magang";
  const spouseOptional = isSpouseFieldsOptional(status_perdata);

  const fieldChecks = {
    nama_lengkap: safeTrim(nama_lengkap) !== "",
    nomor_kk: safeTrim(nomor_kk) !== "",
    nomor_npwp: safeTrim(nomor_npwp) !== "",
    npwp_pemadanan_checked: safeBool(npwp_pemadanan_checked),
    agama: safeTrim(agama) !== "",
    jenis_kelamin: safeTrim(jenis_kelamin) !== "",
    tempat_lahir: safeTrim(tempat_lahir) !== "",
    tanggal_lahir: safeTrim(tanggal_lahir) !== "",
    tanggal_masuk: safeTrim(tanggal_masuk) !== "",
    province: safeCheck(province),
    regency: safeCheck(regency),
    district: safeCheck(district),
    village: safeCheck(village),
    addressDetail: safeTrim(addressDetail) !== "",
    status_perdata: safeTrim(status_perdata) !== "",
    orang_tua_nama_ayah: safeTrim(orang_tua_nama_ayah) !== "",
    orang_tua_nama_ibu: safeTrim(orang_tua_nama_ibu) !== "",
    kontak_darurat_nama: safeTrim(kontak_darurat_nama) !== "",
    kontak_darurat_hubungan: safeTrim(kontak_darurat_hubungan) !== "",
    kontak_darurat_no_telepon: safeTrim(kontak_darurat_no_telepon) !== "",
    nomor_hp: safeTrim(nomor_hp) !== "",
    selected_bank: isPKLMagang ? true : safeTrim(selected_bank) !== "",
    nomor_rekening_bank: isPKLMagang ? true : safeTrim(nomor_rekening_bank) !== "",
    nomor_kartu_bpjs_kesehatan: safeTrim(nomor_kartu_bpjs_kesehatan) !== "",
    email: safeTrim(email) !== "",
    pendidikan_terakhir: safeTrim(pendidikan_terakhir) !== "",
    pendidikan_nama_sekolah: safeTrim(pendidikan_nama_sekolah) !== "",
    pendidikan_jurusan: safeTrim(pendidikan_jurusan) !== "",
    agreement: safeBool(agreement),
    nama_pasangan: spouseOptional ? true : safeTrim(nama_pasangan) !== "",
    tempat_pernikahan: spouseOptional ? true : safeTrim(tempat_pernikahan) !== "",
    tanggal_pernikahan: spouseOptional ? true : safeTrim(tanggal_pernikahan) !== "",
    tempat_lahir_pasangan: spouseOptional
      ? true
      : safeTrim(tempat_lahir_pasangan) !== "",
    tanggal_lahir_pasangan: spouseOptional
      ? true
      : safeTrim(tanggal_lahir_pasangan) !== "",
    pekerjaan_pasangan: spouseOptional ? true : safeTrim(pekerjaan_pasangan) !== "",
    tempat_pasangan_bekerja: spouseOptional
      ? true
      : safeTrim(tempat_pasangan_bekerja) !== "",
    kontak_darurat_hubungan_kerabat:
      state.kontak_darurat_hubungan !== "Kerabat Lainnya"
        ? true
        : safeTrim(kontak_darurat_hubungan_kerabat) !== "",
  };

  const failedFields = Object.entries(fieldChecks)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  const basicFieldsValid = Object.values(fieldChecks).every(Boolean);

  const uploadChecks = {
    foto_pribadi_complete: isUploadComplete(foto_pribadi_status),
    foto_ktp_complete: isUploadComplete(foto_ktp_status),
    foto_npwp_complete: isUploadComplete(foto_npwp_status),
    foto_kk_complete: isUploadComplete(foto_kk_status),
    foto_cv_complete: isUploadComplete(foto_cv_status),
    foto_url_exists: hasNonEmptyTrimmedUrl(foto_url),
    ktp_url_exists: hasNonEmptyTrimmedUrl(ktp_url),
    npwp_url_exists: hasNonEmptyTrimmedUrl(npwp_url),
    kk_url_exists: hasNonEmptyTrimmedUrl(kk_url),
    cv_url_exists: hasNonEmptyTrimmedUrl(cv_url),
  };

  const failedUploads = Object.entries(uploadChecks)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  const requiredUploadsValid = Object.values(uploadChecks).every(Boolean);

  const npwpTrim = typeof npwp_url === "string" ? npwp_url.trim() : "";
  const npwpUploadValid =
    npwpTrim === "" ||
    (hasNonEmptyTrimmedUrl(npwp_url) &&
      isUploadComplete(foto_npwp_status));

  /** Selaras dengan validateRequiredFields di Form.js */
  let rekeningValid = true;

  if (status_karyawan === "staff") {
    const cleanNomor = safeTrim(
      nomor_rekening_bank != null ? String(nomor_rekening_bank) : "",
    );
    const hasValidLength = cleanNomor.length === 10;
    const isNumericOnly = /^\d+$/.test(cleanNomor);
    rekeningValid = hasValidLength && isNumericOnly;
  } else if (isNonstaffStatus(status_karyawan)) {
    const cleanNomor = safeTrim(
      nomor_rekening_bank != null ? String(nomor_rekening_bank) : "",
    );

    if (cleanNomor.length > 0) {
      let requiredDigits = 0;

      if (selected_bank === "mandiri") {
        requiredDigits = 13;
      } else if (selected_bank === "mas") {
        requiredDigits = 10;
      } else if (selected_bank === "" && cleanNomor.length > 0) {
        if (cleanNomor.length === 10) {
          requiredDigits = 10;
        } else if (cleanNomor.length === 13) {
          requiredDigits = 13;
        } else {
          rekeningValid = false;
        }
      }

      if (requiredDigits > 0) {
        const hasValidLength = cleanNomor.length === requiredDigits;
        const isNumericOnly = /^\d+$/.test(cleanNomor);
        rekeningValid = hasValidLength && isNumericOnly;
      }
    } else {
      rekeningValid = false;
    }
  } else {
    rekeningValid = true;
  }

  /** Selaras dengan onSubmit: jika Mandiri/MAS terpilih, panjang & angka harus tepat */
  let bankSelectionMatchesNumber = true;
  if (selected_bank === "mandiri" || selected_bank === "mas") {
    const requiredDigits = selected_bank === "mandiri" ? 13 : 10;
    const nomorStr =
      nomor_rekening_bank != null ? String(nomor_rekening_bank).trim() : "";
    bankSelectionMatchesNumber =
      nomorStr.length === requiredDigits && /^\d+$/.test(nomorStr);
  }

  const helperMarried =
    status_karyawan === "nonstaff helper" &&
    safeTrim(status_perdata) === "Menikah";

  const finalResult =
    basicFieldsValid &&
    requiredUploadsValid &&
    npwpUploadValid &&
    rekeningValid &&
    bankSelectionMatchesNumber &&
    !helperMarried;

  let errorMessage = "";
  if (!finalResult) {
    const parts = [];
    if (helperMarried) {
      parts.push("Status perkawinan nonstaff helper harus belum kawin");
    }
    if (failedFields.length > 0) {
      parts.push(
        `Field: ${failedFields.slice(0, 8).join(", ")}${failedFields.length > 8 ? "…" : ""}`,
      );
    }
    if (failedUploads.length > 0) {
      parts.push(`Upload/URL: ${failedUploads.join(", ")}`);
    }
    if (!rekeningValid || !bankSelectionMatchesNumber) {
      parts.push(
        "Nomor rekening bank tidak valid untuk status karyawan / bank terpilih",
      );
    }
    if (!npwpUploadValid && requiredUploadsValid) {
      parts.push("Dokumen NPWP");
    }
    errorMessage =
      parts.length > 0
        ? `Data Form 1 belum valid. ${parts.join(" ")}`
        : "Data Form 1 belum valid.";
  }

  return {
    ok: finalResult,
    failedFields,
    failedUploads,
    rekeningValid,
    bankSelectionMatchesNumber,
    errorMessage,
  };
}
